import { render, staticRenderFns } from "./CoozzyInfoCircleIcon.vue?vue&type=template&id=a142e604&scoped=true"
import script from "./CoozzyInfoCircleIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyInfoCircleIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyInfoCircleIcon.vue?vue&type=style&index=0&id=a142e604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a142e604",
  null
  
)

export default component.exports